import { __extends } from "tslib";
import { StencilState } from "../../States/stencilState";
/**
 * @hidden
 **/

var WebGPUStencilState =
/** @class */
function (_super) {
  __extends(WebGPUStencilState, _super);

  function WebGPUStencilState(cache) {
    var _this = _super.call(this, false) || this;

    _this._cache = cache;

    _this.reset();

    return _this;
  }

  Object.defineProperty(WebGPUStencilState.prototype, "stencilFunc", {
    get: function get() {
      return this._stencilFunc;
    },
    set: function set(value) {
      if (this._stencilFunc === value) {
        return;
      }

      this._stencilFunc = value;
      this._isStencilFuncDirty = true;

      this._cache.setStencilCompare(value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(WebGPUStencilState.prototype, "stencilFuncRef", {
    get: function get() {
      return this._stencilFuncRef;
    },
    set: function set(value) {
      if (this._stencilFuncRef === value) {
        return;
      }

      this._stencilFuncRef = value;
      this._isStencilFuncDirty = true;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(WebGPUStencilState.prototype, "stencilFuncMask", {
    get: function get() {
      return this._stencilFuncMask;
    },
    set: function set(value) {
      if (this._stencilFuncMask === value) {
        return;
      }

      this._stencilFuncMask = value;
      this._isStencilFuncDirty = true;

      this._cache.setStencilReadMask(value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(WebGPUStencilState.prototype, "stencilOpStencilFail", {
    get: function get() {
      return this._stencilOpStencilFail;
    },
    set: function set(value) {
      if (this._stencilOpStencilFail === value) {
        return;
      }

      this._stencilOpStencilFail = value;
      this._isStencilOpDirty = true;

      this._cache.setStencilFailOp(value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(WebGPUStencilState.prototype, "stencilOpDepthFail", {
    get: function get() {
      return this._stencilOpDepthFail;
    },
    set: function set(value) {
      if (this._stencilOpDepthFail === value) {
        return;
      }

      this._stencilOpDepthFail = value;
      this._isStencilOpDirty = true;

      this._cache.setStencilDepthFailOp(value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(WebGPUStencilState.prototype, "stencilOpStencilDepthPass", {
    get: function get() {
      return this._stencilOpStencilDepthPass;
    },
    set: function set(value) {
      if (this._stencilOpStencilDepthPass === value) {
        return;
      }

      this._stencilOpStencilDepthPass = value;
      this._isStencilOpDirty = true;

      this._cache.setStencilPassOp(value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(WebGPUStencilState.prototype, "stencilMask", {
    get: function get() {
      return this._stencilMask;
    },
    set: function set(value) {
      if (this._stencilMask === value) {
        return;
      }

      this._stencilMask = value;
      this._isStencilMaskDirty = true;

      this._cache.setStencilWriteMask(value);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(WebGPUStencilState.prototype, "stencilTest", {
    get: function get() {
      return this._stencilTest;
    },
    set: function set(value) {
      if (this._stencilTest === value) {
        return;
      }

      this._stencilTest = value;
      this._isStencilTestDirty = true;

      this._cache.setStencilEnabled(value);
    },
    enumerable: false,
    configurable: true
  });

  WebGPUStencilState.prototype.reset = function () {
    _super.prototype.reset.call(this);

    this._cache.resetStencilState();
  };

  WebGPUStencilState.prototype.apply = function (gl) {// nothing to do
  };

  return WebGPUStencilState;
}(StencilState);

export { WebGPUStencilState };